// extracted by mini-css-extract-plugin
export default {"error404":"NotFound_error404__PN8Ch","container":"NotFound_container__nbDmt"};